
import { useState } from "react"
import { BiReset } from "react-icons/bi"
import { CiPillsBottle1 } from "react-icons/ci"
import { IoChevronForwardCircleOutline } from "react-icons/io5"
import { LuPackageSearch } from "react-icons/lu"
import { VscTypeHierarchy } from "react-icons/vsc"
import { useDispatch, useSelector } from "react-redux"

import { ANNUAL_SUMMARY_TAB_ID } from "../../../../shared/constants"
import { RootState } from "../../../../store"
import { forecastComparisonTabActions } from "../../../../store/slices/annual-summary-tab-slice"
import { tradeAndPromoPlanningTabActions } from "../../../../store/slices/trade-and-promo-planning-tab-slice"
import CheckboxDropdown from "../../../UI/CheckboxDropdown/CheckboxDropdown"
import RadioDropdown from "../../../UI/RadioDropdown/RadioDropdown"
import { AnnualSummarySelectedSlicerModel } from "../../../../models/TradeAndPromoPlanning/AnnualSummarySlicer.model"
import { getDefaultSlicersForForecastEntryApp } from "../../../../shared/functions"

const AnnualSummarySlicers = () => {
    // States
    const [isSlicerChanged, setIsSlicerChanged] = useState<boolean>(false);
    
    // Redux variables
    const dispatchFn = useDispatch()
    const slicers = useSelector((state: RootState) => state.annualSummaryTab.slicers);
    const hierarchies: any = [
        { name: 'Brand', value: 'Brand' },
        { name: 'Brand-SubBrand', value: 'Brand-SubBrand' },
        { name: 'Brand-SubBrand-VolumeSize', value: 'Brand-SubBrand-VolumeSize' }
    ];
    const hierarchy = useSelector((state: RootState) => state.annualSummaryTab.hierarchy)
    const tempSelectedSlicers = useSelector((state: RootState) => state.annualSummaryTab.tempSelectedSlicers)

    const applySelectedSlicers = (event: any) => {
        const tempSlicers: AnnualSummarySelectedSlicerModel = { ...tempSelectedSlicers };
        const selectedSlicers: any = {
            brand: tempSlicers.brand.includes('All') ? ['All'] : tempSlicers.brand,
            subBrand: tempSlicers.subBrand.includes('All') ? ['All'] : tempSlicers.subBrand,
            volumeSize: tempSlicers.volumeSize.includes('All') ? ['All'] : tempSlicers.volumeSize
        };

        dispatchFn(forecastComparisonTabActions.setSelectedSlicers(selectedSlicers));
        dispatchFn(tradeAndPromoPlanningTabActions.setTabApiDataFetched({
            [ANNUAL_SUMMARY_TAB_ID]: false
        }));
        setIsSlicerChanged(false);
    };

    const resetSelectedSlicers = (event: any) => {
        const defaultSlicers: AnnualSummarySelectedSlicerModel = getDefaultSlicersForForecastEntryApp(ANNUAL_SUMMARY_TAB_ID);

        if (
            tempSelectedSlicers.brand.toSorted().toString() !== defaultSlicers.brand.toSorted().toString() ||
            tempSelectedSlicers.subBrand.toSorted().toString() !== defaultSlicers.subBrand.toSorted().toString() ||
            tempSelectedSlicers.volumeSize.toSorted().toString() !== defaultSlicers.volumeSize.toSorted().toString() ||
            hierarchy !== 'Brand-SubBrand-VolumeSize'
        ) {
            dispatchFn(forecastComparisonTabActions.resetSelectedSlicers(null));
            dispatchFn(tradeAndPromoPlanningTabActions.setTabApiDataFetched({
                [ANNUAL_SUMMARY_TAB_ID]: false
            }));
            setIsSlicerChanged(false);
        }
    };

    /**
     * Event handler for dropdown value change.
     * @param {string} field Slicer field which was updated.
     * @param {string | string[]} value Updated slicer value(s).
     */
    const dropdownItemChangeHandler = (field: string, value: string | string[]) => {
        dispatchFn(forecastComparisonTabActions.setTempSelectedSlicers({
            ...tempSelectedSlicers,
            [field]: value
        }));
        setIsSlicerChanged(true);
    };

    const dropdownItemChangeHandlerRadioDropdown = (dropdownItemValue: any) => {
        dispatchFn(forecastComparisonTabActions.setHierarchy(
            dropdownItemValue
        ));
        setIsSlicerChanged(true);
    };


    return (
        <>  
        <div className="col">
            <div className="col-12">
                <div className="my-1">
                    <CheckboxDropdown
                        id="forecast-comparison-dropdown"
                        icon={<LuPackageSearch size={20} />}
                        label="Product Brand(s)"
                        selectedValues={tempSelectedSlicers.brand}
                        items={slicers.brand}
                        onItemChanged={(value: any) => dropdownItemChangeHandler("brand", value)}
                    />

                    <CheckboxDropdown
                        id="forecast-comparison-dropdown"
                        icon={<VscTypeHierarchy size={20} />}
                        label="Product Sub-Brand(s)"
                        selectedValues={tempSelectedSlicers.subBrand}
                        items={slicers.subBrand}
                        onItemChanged={(value: any) => dropdownItemChangeHandler("subBrand", value)}
                    />
                </div>
                <div className="my-1">
                    <CheckboxDropdown
                        id="forecast-comparison-dropdown"
                        icon={<CiPillsBottle1 size={20} />}
                        label="Product Volume Size(s)"
                        selectedValues={tempSelectedSlicers.volumeSize}
                        items={slicers.volumeSize}
                        onItemChanged={(value: any) => dropdownItemChangeHandler("volumeSize", value)}
                    />

                    <RadioDropdown
                        id="forecast-comparison-dropdown"
                        icon={<LuPackageSearch size={20} />}
                        label="Hierarchy"
                        selectedValue={hierarchy}
                        items={hierarchies}
                        onItemChanged={(value: any) => dropdownItemChangeHandlerRadioDropdown(value)}
                    />
                    <div className="d-inline me-1">
                        <button type="button" className="btn btn-sm text-white" style={{ backgroundColor: "#00833E" }} onClick={applySelectedSlicers} disabled={!isSlicerChanged}>
                            <div className="d-flex justify-content-center align-items-center">
                                <IoChevronForwardCircleOutline size={20} /> &nbsp;Apply filters
                            </div>
                        </button>
                    </div>

                    <div className="d-inline">
                        <button type="button" className="btn btn-sm btn-warning" onClick={resetSelectedSlicers}>
                            <div className="d-flex justify-content-center align-items-center">
                                <BiReset size={20} /> &nbsp;Reset filters
                            </div>
                        </button>
                    </div>
                </div>
                
            </div>
            
        </div>
            

        </>
    )
}
export default AnnualSummarySlicers

